import { FeatureTileDto } from "../../../../../../@api";

export const DEFAULT_TEXT_COLOR = "#ffffff";
export const DEFAULT_BG_COLOR =
  "linear-gradient(-225deg, rgba(50, 31, 133, 0.6) 0%, rgba(155, 31, 155, 0.6) 70%, rgba(237, 47, 160, 0.6) 100%)";
export const DEFAULT_BG_HOVER_COLOR =
  "linear-gradient(-225deg, rgba(50, 31, 133, 0.6) 0%, rgba(155, 31, 155, 0.6) 50%, rgba(237, 47, 160, 0.6) 100%)";

export const TITLE_MAX_LENGTH = 50;
export const DESCRIPTION_MAX_LENGTH = 250;
export const BUTTON_TEXT_MAX_LENGTH = 30;

export type MultiLang = { [key: string]: string };

export const emptyMultiLang = (): MultiLang => ({ en: "", de: "", fr: "" });

export interface IFeatureTileEditorDialogState {
  tileId: string | undefined | null;
  order: number;
  isSaving: boolean;
  enabled: boolean;
  iconKey: string;
  externalLinkUrl: MultiLang;
  colorTextRaw: string;
  colorBackgroundRaw: string;
  colorBackgroundHoverRaw: string;
  title: MultiLang;
  description: MultiLang;
  buttonText: MultiLang;
  buttonTooltip: MultiLang;
}

export const createInitialFeatureTileEditorDialogState = (
  tile: FeatureTileDto | null,
  defaultOrder: number,
): IFeatureTileEditorDialogState => ({
  tileId: tile?.id,
  order: tile?.order ?? defaultOrder,
  isSaving: false,
  enabled: tile?.enabled ?? true,
  iconKey: tile?.iconKey ?? "externalLink",
  externalLinkUrl: tile?.linkUrl ?? emptyMultiLang(),
  colorTextRaw: tile?.colorText ?? DEFAULT_TEXT_COLOR,
  colorBackgroundRaw: tile?.colorBackground ?? DEFAULT_BG_COLOR,
  colorBackgroundHoverRaw: tile?.colorBackgroundHover ?? DEFAULT_BG_HOVER_COLOR,
  title: tile?.title ?? emptyMultiLang(),
  description: tile?.description ?? emptyMultiLang(),
  buttonText: tile?.buttonText ?? emptyMultiLang(),
  buttonTooltip: tile?.tooltip ?? emptyMultiLang(),
});

export const createFeatureTileDto = (
  state: IFeatureTileEditorDialogState,
  defaultOrder: number,
  colors: {
    colorText?: string;
    colorBackground?: string;
    colorBackgroundHover?: string;
  },
): FeatureTileDto => ({
  id: state.tileId,
  enabled: state.enabled,
  showFooter: false,
  order: state.order ?? defaultOrder,
  title: state.title,
  description: state.description,
  buttonText: state.buttonText,
  tooltip: state.buttonTooltip,
  linkUrl: state.externalLinkUrl,
  iconKey: state.iconKey,
  colorText: (colors.colorText ?? DEFAULT_TEXT_COLOR).toUpperCase(),
  colorBackground: colors.colorBackground ?? DEFAULT_BG_COLOR,
  colorBackgroundHover: colors.colorBackgroundHover ?? DEFAULT_BG_HOVER_COLOR,
});
